import { apiClient } from "../config";

async function getDetailDataPortal(id: any) {
  
  const res = await apiClient.get(`/admin/data-portals/${id}`)
  return res.data;
}

export default getDetailDataPortal;
